// Controle global de áudios (velocidade persistente + apenas 1 tocando por vez)
const STORAGE_KEY = "whaticket_audio_playback_rate";

export const RATES = [1, 1.5, 2];

const listeners = new Set();
const audios = new Set();

export const readRate = () => {
	try {
		const v = parseFloat(localStorage.getItem(STORAGE_KEY));
		if (RATES.includes(v)) return v;
	} catch (_) { /* ignore */ }
	return 1;
};

export const setRate = (rate) => {
	if (!RATES.includes(rate)) return;
	try { localStorage.setItem(STORAGE_KEY, String(rate)); } catch (_) { /* ignore */ }
	listeners.forEach((fn) => { try { fn(rate); } catch (_) { /* ignore */ } });
};

export const subscribe = (fn) => {
	listeners.add(fn);
	return () => { listeners.delete(fn); };
};

export const nextRate = (current) => {
	const idx = RATES.indexOf(current);
	return RATES[(idx + 1) % RATES.length];
};

export const registerAudio = (el) => {
	if (!el) return () => {};
	audios.add(el);
	return () => { audios.delete(el); };
};

export const pauseOthers = (current) => {
	audios.forEach((el) => {
		if (el && el !== current && !el.paused) {
			try { el.pause(); } catch (_) { /* ignore */ }
		}
	});
};
